//品牌
export function showvideo(videovesrion) {
    return {
        type: 'SET/BRAND/VIDEO',
        videovesrion: videovesrion,
    }
}